import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import { reactive, computed, toRefs, ref } from "vue";
import { viewModeEnum, itemTypeEnum } from "@/enums/components/list";
import { UtilityService } from "@/utils";
import { useRoute } from "vue-router";
import { SpeakerTypeEnum } from "@/enums/api/index";
export default {
  name: "videoCard",
  setup(props) {
    const outlineList = ref(null);
    const {
      groupInfo,
      viewMode,
      langPath
    } = toRefs(props);
    const {
      videoType,
      getDescriptionAndTimecode,
      getVideoType,
      textToHtml,
      formatSeconds
    } = UtilityService;
    const state = reactive({
      viewModeType: viewModeEnum,
      timecode: computed(() => UtilityService.getDescriptionAndTimecode(groupInfo.value.description).timecode),
      displayTimecode: [],
      isBookmarked: computed(() => groupInfo.value.isBookmarked),
      detailLink: computed(() => {
        const route = useRoute();
        const isSkillPath = groupInfo.value.type === itemTypeEnum.SKILL_PATH;
        const url = isSkillPath ? groupInfo.value.category[0] + `/${groupInfo.value.urlName}` : groupInfo.value.category.join("/");
        return {
          path: (langPath.value ? langPath.value : "/") + url,
          query: {
            ...route.query,
            ...(isSkillPath ? {} : {
              v: groupInfo.value.urlName
            })
          }
        };
      }),
      date: groupInfo.value.date,
      category: computed(() => {
        return getVideoType(groupInfo.value.category[0]).display;
      }),
      videoType: computed(() => {
        return getVideoType(groupInfo.value.category[0]).type;
      }),
      description: computed(() => {
        return textToHtml(getDescriptionAndTimecode(groupInfo.value.description).description, false);
      }),
      isWaitingLoading: computed(() => groupInfo.value.thumbnail ? false : true),
      isShowOutline: false,
      speakerNames: computed(() => (groupInfo.value.speakers || []).map(speaker => speaker.name).join(',  '))
    });
    /* eslint-disable */
    let addOpenTimer = null;
    const showOutline = event => {
      addOpenTimer = setTimeout(function () {
        state.isShowOutline = true;
      }, 500);
      const outline = $(outlineList.value);
      const iconViewModeOutlinePosition = {
        right: {
          position: "absolute",
          top: "50%",
          bottom: "auto",
          left: "calc(100% + 10px)",
          right: "auto",
          transform: 'translateY(-50%)'
        },
        left: {
          position: "absolute",
          top: "50%",
          bottom: "auto",
          left: "auto",
          right: "calc(100% + 10px)",
          transform: 'translateY(-50%)'
        },
        bottom: {
          position: "absolute",
          top: "calc(100% + 10px)",
          bottom: "auto",
          left: "50%",
          bottom: "auto",
          transform: 'translateX(-50%)'
        },
        top: {
          position: "absolute",
          top: "auto",
          bottom: "100%",
          left: "50%",
          bottom: "auto",
          transform: 'translate(-50% ,-105%)'
        }
      };
      const detailViewModeOutlinePosition = {
        "img-container": {
          bottom: {
            position: "absolute",
            top: "calc(100% + 10px)",
            bottom: "auto",
            left: $(event.target).width() + 10,
            transform: 'translateX(-50%)'
          },
          top: {
            position: "absolute",
            top: "auto",
            bottom: "calc(100% + 10px)",
            left: $(event.target).width() + 10,
            transform: 'translateX(-50%)'
          }
        },
        "group-title": {
          right: {
            position: "absolute",
            top: "50%",
            bottom: "auto",
            left: $(event.target).width() + $('.img-container').width() + 30,
            right: "auto",
            transform: 'translateY(-50%)'
          },
          bottom: {
            position: "absolute",
            top: $(event.target).position().top + $(event.target).height() + 10,
            bottom: "auto",
            left: $(event.target).width() + $('.img-container').width() + 30,
            bottom: "auto",
            transform: 'translateX(-50%)'
          },
          top: {
            position: "absolute",
            top: -($(event.target).position().top + $(event.target).height() + 20),
            bottom: "auto",
            left: $(event.target).width() + $('.img-container').width() + 30,
            bottom: "auto",
            transform: 'translateX(-50%)'
          }
        }
      };
      const hoverOnElement = Object.keys(detailViewModeOutlinePosition).find(element => $(event.target).attr("class").split(/\s+/).indexOf(element) > -1);
      const setOutlinePosition = (position, type) => {
        outline.attr("class", "outline-list");
        outline.addClass(position);
        if (viewMode.value === state.viewModeType.DETAILS) {
          outline.css(detailViewModeOutlinePosition[hoverOnElement][position]);
        } else {
          outline.css(iconViewModeOutlinePosition[position]);
        }
      };
      const getPositionforOutline = checkPosition => {
        if (checkPosition.indexOf("right") > -1 && $(window).width() - outline.offset().left > outline.width()) {
          //element到window右邊空間容納的下outline的寬度，顯示在右側
          setOutlinePosition("right");
        }
        if (checkPosition.indexOf("left") > -1 && $(window).width() - outline.offset().left < outline.width()) {
          //element到window右邊空間容納不下outline的寬度，顯示在左側
          setOutlinePosition("left");
        }
        if (checkPosition.indexOf("bottom") > -1 && outline.offset().top - $(window).scrollTop() < 0 || $(window).width() - outline.offset().left < outline.width()) {
          //element到window上邊空間容納不下outline的高度，顯示在下方
          setOutlinePosition("bottom");
        }
        if (checkPosition.indexOf("top") > -1 && outline.offset().top - $(window).scrollTop() > $(window).height() - outline.height() //element到window下邊空間容納不下outline的高度，顯示在上方
        ) {
          setOutlinePosition("top");
        }
      };
      if (viewMode.value === state.viewModeType.DETAILS) {
        if (hoverOnElement == "img-container") {
          setOutlinePosition("bottom");
        }
        outline.css({
          width: $("." + hoverOnElement).width()
        });
        getPositionforOutline(Object.keys(detailViewModeOutlinePosition[hoverOnElement]));
      } else {
        outline.css("position", "absolute"), getPositionforOutline(["right", "left", "top", "bottom"]);
      }
      const leftSpaceForList = $(".video-card").innerHeight() - $(".outline-title").height() - 50;
      state.displayTimecode = [];
      let allListHeight = 0;
      let maxListLength = null;
      outline.find(".outline-content li").each(function (index) {
        if (leftSpaceForList <= allListHeight) {
          maxListLength = index;
          return false;
        } else {
          allListHeight = allListHeight + $(this).height() + 10;
        }
      });
      if (maxListLength) {
        state.displayTimecode = state.timecode.slice(0, maxListLength - 1);
        state.displayTimecode.push({
          text: "......"
        });
      } else {
        state.displayTimecode = UtilityService.getDescriptionAndTimecode(groupInfo.value.description).timecode;
      }
      state.timecode = UtilityService.getDescriptionAndTimecode(groupInfo.value.description).timecode;
    };
    const hideOutline = event => {
      clearTimeout(addOpenTimer);
      $(event.target).removeClass("open");
      state.isShowOutline = false;
    };
    return {
      state,
      showOutline,
      hideOutline,
      formatSeconds,
      outlineList,
      videoType,
      UtilityService
    };
  },
  props: {
    viewMode: {
      type: Number,
      required: true
    },
    groupInfo: {
      type: Object,
      required: true
    },
    position: {
      type: Number,
      required: true
    },
    langPath: {
      type: String,
      required: true
    },
    isShowDeleteHistoryButton: {
      type: Boolean,
      default: false,
      required: false
    },
    deleteHistoryHandler: {
      type: Function,
      required: false,
      default() {
        return () => true;
      }
    },
    impressionHandler: {
      type: Function,
      required: false,
      default() {
        return () => true;
      }
    },
    clickCardHandler: {
      type: Function,
      required: false,
      default() {
        return () => true;
      }
    },
    clickBookmarkHandler: {
      type: Function,
      required: true,
      default() {
        return () => true;
      }
    },
    isShowVersionHeight: {
      type: Boolean,
      required: true,
      default: false
    }
  }
};